module.exports = __webpack_public_path__ + "media/images/webpage/shared/asterisk-5c3ad041e523a148e478b23f582a0eac.svg";